<div class="modals cards" [class.modals-show]="isModalCardsShow" [class.modals-hide]="!isModalCardsShow">
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="requisition-message">
    <p class="attention">
      Увага!
    </p>
    <p>
      Реквізити для оплати не зберігати! Актуальні реквізити після замовлення.
    </p>
  </div>
  <a *ngIf="cards && cards.length > 0" (click)="showPaymentModal()" class="pay-notify button">Повідомити про оплату</a>
  <div *ngFor="let card of cards" class="bankdata">
    <ng-container *ngIf="card.req_type === 'card_req'">
      <p>{{ card.bank_name }}</p>
      <p class="cardnumber">{{ card.card_number }}</p>
      <p class="cardholder">{{ card.full_name }}</p>
      <br>
      <p *ngIf="card.comment" [innerHTML]="card.comment" class="cardholder"></p>
    </ng-container>
    <ng-container *ngIf="card.req_type === 'fop_req'">
      <p>{{ card.bank_name }}</p>
      <p class="cardnumber">{{ card.card_number }}</p>
      <p class="cardholder">{{ card.full_name }}</p>
      <br>
      <p *ngIf="card.comment" [innerHTML]="card.comment" class="cardholder"></p>
    </ng-container>
    <ng-container *ngIf="card.req_type === 'cash'">
      <p>{{ card.bank_name }}</p>
      <p class="cardnumber">{{ card.card_number }}</p>
      <p class="cardholder">{{ card.full_name }}</p>
      <br>
      <p *ngIf="card.comment" [innerHTML]="card.comment" class="cardholder"></p>
    </ng-container>
    <ng-container *ngIf="card.req_type === 'bank_req'">
      <p class="cardholder">{{ card.organization }}</p>
      <p class="cardholder">IBAN:</p>
      <p class="cardnumber">{{ card.iban }}</p>
      <p class="cardholder">ЕДРПОУ: {{ card.edrpou }}</p>
      <p class="cardholder">{{ card.bank_name }}</p>
      <p class="cardholder">МФО: {{ card.mfo }}</p>
      <p *ngIf="card.comment" [innerHTML]="card.comment" class="cardholder"></p>
    </ng-container>
    <hr>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
